import { FC } from 'react'
import { ICompanyBase } from '@/types'
import { getCompanyLogo } from '@/utils'
import { AvatarContentFullCard } from '@components-v2/molecules/AvatarContentFullCard'
import { StartUpCardContent } from '@components-v2/molecules/StartUpCardContent'

type Props = {
  item: ICompanyBase
  shouldDisplayInvestorType?: boolean
}

export const StartUpCard: FC<Props> = ({ item }) => {
  return (
    <AvatarContentFullCard
      src={getCompanyLogo(item)}
      // 現状 status が published の会社しか item に入ることはないが、今後 closed な会社が入る可能性があるので href に条件を記載した
      href={item.status === 'published' ? `/companies/${item.slug}` : ''}
    >
      <StartUpCardContent company={item} />
    </AvatarContentFullCard>
  )
}
